export const bsrWhitelist = {
  appNames: ['Bitlauncher', 'dBoard'],
  websites: [
    /^https:\/\/(bitlauncher.ai|[a-z0-9.-]+.bitlauncher.ai).*$/,
    /^https:\/\/(dboard.ai|[a-z0-9.-]+.dboard.ai).*$/,
  ],
} as const
